"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorResult = exports.SuccessResult = void 0;
class SuccessResult {
    constructor(data) {
        this.isSuccess = true;
        this.data = data;
    }
    static create(data) {
        return new SuccessResult(data);
    }
}
exports.SuccessResult = SuccessResult;
class ErrorResult {
    constructor(error) {
        this.isSuccess = false;
        this.error = error;
    }
    static create(error) {
        return new ErrorResult(error);
    }
}
exports.ErrorResult = ErrorResult;
//# sourceMappingURL=result.js.map